import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { LoadingButton } from "@mui/lab";

const PopupDialog = props => {
  return (
    <div>
      <Dialog open={props.state} onClose={props.onClose}>
        <DialogTitle>{props.dialogMessage || "Are you sure?"}</DialogTitle>
        <DialogContent>
          {/* Add your dialog content here if needed */}
          {props.children}
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={props.onClose}
            variant="outlined"
            color="secondary"
          >
            {props.cancelBtnText || "Cancel"}
          </LoadingButton>
          {props.confirmBtnText && (
            <LoadingButton
              onClick={props.onConfirm}
              loading={props.isLoading}
              color={`${props.isDestructiveAction ? "error" : "primary"}`}
              variant="contained"
            >
              {props.confirmBtnText || "Confirm"}
            </LoadingButton>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

PopupDialog.propTypes = {
  state: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDestructiveAction: PropTypes.bool,
  dialogMessage: PropTypes.string,
  confirmBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
};

export default PopupDialog;
